/**
 * Created by Christof Sander on 27.01.2017.
 */

module.exports = {
	methods: {
		prepare: function(storage){
			var user = (storage|| {}).user
			if(user) 	this.model.extendedButtonActionsGranted = user.hasAccessTo('usage:media:extendedButtonActions', this.scope)
			else 		this.model.extendedButtonActionsGranted = false;
		}
	}
};
